import { ActionType } from 'typesafe-actions';
import * as virtualCard from './actions';
import {
  TransactionListItem,
  UserVirtualCardResponse,
  VirtualCardMerchantOfferResponse,
} from '../../library/interfaces';
import {
  SET_SELECTED_CARD_INFO,
  SET_SELECTED_CARD_TRANSACTIONS,
  SET_SELECTED_TRANSACTION,
  SET_VIRTUAL_CARD_OFFER,
  SET_VIRTUAL_CARDS_LIST,
  SET_VIRTUAL_CARDS_ITEM_OPTIMISTIC_UPDATE,
} from './constants';

export type VirtualCardAction = ActionType<typeof virtualCard>;

export type VirtualCardState = {
  virtualCardOffers: VirtualCardMerchantOfferResponse;
  currentCardInfo: null | Record<any, any>;
  currentTransactionInfo: null | TransactionListItem;
  virtualCardsList: UserVirtualCardResponse | null;
};

const defaultState: VirtualCardState = {
  virtualCardOffers: {} as VirtualCardMerchantOfferResponse,
  currentCardInfo: {
    payload: {},
    cloPayload: {},
    totalUserCloSpending: 0,
    accountBalance: 0,
    openToTransactionType: null,
  },
  currentTransactionInfo: null,
  virtualCardsList: null,
};

export default (state = defaultState, action: VirtualCardAction): VirtualCardState => {
  switch (action.type) {
    case SET_VIRTUAL_CARD_OFFER:
      return {
        ...state,
        virtualCardOffers: action.payload,
      };
    case SET_SELECTED_CARD_INFO: {
      return {
        ...state,
        currentCardInfo: {
          ...action.payload,
        },
      };
    }
    case SET_SELECTED_CARD_TRANSACTIONS: {
      return {
        ...state,
        currentCardInfo: {
          ...state.currentCardInfo,
          transactions: action.payload,
        },
      };
    }
    case SET_SELECTED_TRANSACTION: {
      return {
        ...state,
        currentTransactionInfo: action.payload,
      };
    }
    case SET_VIRTUAL_CARDS_LIST: {
      return {
        ...state,
        virtualCardsList: action.payload,
      };
    }
    case SET_VIRTUAL_CARDS_ITEM_OPTIMISTIC_UPDATE: {
      if (!state.virtualCardsList) return state;

      const virtualCardList = state.virtualCardsList.rows.map((item) => {
        if (item.id === action.payload.id) {
          return {
            ...item,
            ...action.payload,
          };
        }
        return item;
      });

      return {
        ...state,
        virtualCardsList: {
          ...state.virtualCardsList,
          rows: virtualCardList,
        },
      };
    }
    default:
      return state;
  }
};
